import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClienteService } from '../http-cliente.service';

export interface OrderFlowState {
  clientId: string | null;
  orderPending: boolean;
  timestamp?: number;
  notifications?: any[];
}

@Injectable({ providedIn: 'root' })
export class OrderFlowService {
  private readonly STORAGE_KEY = 'orderFlow';
  private readonly url = environment.apiURL;

  constructor(
    private readonly _http: HttpClienteService,
  ) {}

  private readonly state$ = new BehaviorSubject<OrderFlowState | null>(
    this.loadFromStorage()
  );

  getState$(): Observable<OrderFlowState | null> {
    return this.state$.asObservable();
  }

  getSnapshot(): OrderFlowState | null {
    return this.state$.getValue();
  }

  setOrderPending(clientId: string, notifications?: any[]): void {
    const newState: OrderFlowState = {
      clientId,
      orderPending: true,
      timestamp: Date.now(),
      notifications: notifications || undefined,
    };

    this.state$.next(newState);
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(newState));
  }

  clear(): void {
    this.state$.next(null);
    sessionStorage.removeItem(this.STORAGE_KEY);
  }

  private loadFromStorage(): OrderFlowState | null {
    try {
      const raw = sessionStorage.getItem(this.STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  getOrderDetail(orderInternalCode: string) {
    const query = `${this.url}/wcl-order/detail-by-order-internal-code?orderInternalCode=${orderInternalCode}`;
    return this._http.get(query);
  }
}

